import { lazy } from "react";
import Loadable from "app/components/Loadable";

const SystemUserManagement = Loadable(lazy(() => import("./SystemUserManagement")));
const AppUserManagement = Loadable(lazy(() => import("./AppUserManagement")));
const RoleManagement = Loadable(lazy(() => import("./RoleManagement")));

const authRoutes = [
  { path: "/auth/system-users", element: <SystemUserManagement /> },
  { path: "/auth/app-users", element: <AppUserManagement /> },
  { path: "/auth/role", element: <RoleManagement /> }
];

export default authRoutes;
